// MapButton.js
var MapButton = pc.createScript('mapButton');

MapButton.attributes.add('MapPanel', {type: 'entity'});
MapButton.attributes.add('CloseButton', {type: 'entity'});

MapButton.prototype.initialize = function() {

    this.entity.button.on('click',function(){
        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "MapButton:Click", 1);}
        this.MapPanel.enabled = true;
        MapManager.instance.InitializeMap();
    },this);

    this.CloseButton.button.on('click', function(){
        
        MapManager.instance.anim.stop();
        MapManager.instance.rankElement.setLocalScale(1,1,1);
        this.MapPanel.enabled = false;
    },this);

};


